/**
 * @fileoverview Shared Status schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS, StatusCategoryEnum } from './types.js';

export const StatusSchema = createDisplayableEntitySchema(
  ID_PATTERNS.STATUS,
  'ID must be in st-prefixed nanoid7 format',
  {
    accountTracking: 'standard',
    additionalFields: {
      status_category: StatusCategoryEnum.default('new'),
    },
  }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(StatusSchema);

export const StatusCreateSchema = CreateSchema;
export const StatusUpdateSchema = UpdateSchema;

export type Status = z.infer<typeof StatusSchema>;
export type StatusCreate = z.infer<typeof StatusCreateSchema>;
export type StatusUpdate = z.infer<typeof StatusUpdateSchema>;

export const STATUS_FIELDS = getSchemaFields(StatusSchema);
